import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import {
	SignalsServiceProviderSymbol,
	SignalsPageServiceProviderSymbol,
	WixCodeSdkHandlersProviderSym,
} from '@wix/thunderbolt-symbols'
import { NamedSignalsServiceClient, NamedSignalsServiceServer } from './namedSignalsService'
import { NamedSignalsHandlers } from './namedSignalsHandlersProvider'
import { NamedSignalsHandlersSymbol } from './symbols'

export const site: ContainerModuleLoader = (bind) => {
	if (process.env.browser) {
		bind(NamedSignalsHandlersSymbol, WixCodeSdkHandlersProviderSym).to(NamedSignalsHandlers)
		bind(SignalsServiceProviderSymbol).to(NamedSignalsServiceClient)
	} else {
		bind(SignalsServiceProviderSymbol, WixCodeSdkHandlersProviderSym).to(NamedSignalsServiceServer)
	}
}

export const page: ContainerModuleLoader = (bind) => {
	if (process.env.browser) {
		bind(SignalsPageServiceProviderSymbol).to(NamedSignalsServiceClient)
	} else {
		bind(SignalsPageServiceProviderSymbol, WixCodeSdkHandlersProviderSym).to(NamedSignalsServiceServer)
	}
}

export const editor: ContainerModuleLoader = (bind) => {
	bind(NamedSignalsHandlersSymbol, WixCodeSdkHandlersProviderSym).to(NamedSignalsHandlers)
	bind(SignalsServiceProviderSymbol).to(NamedSignalsServiceClient)
}

export const editorPage: ContainerModuleLoader = (bind) => {
	bind(SignalsPageServiceProviderSymbol).to(NamedSignalsServiceClient)
}

export type { NamedSignalsSdkHandlers, SignalChangeCallback } from './types'
